export const comments_5129826 = {"data":{"data":[],"links":{}}}